<div class="surface-papier" 
[ngClass]="{
	'full-width': fullWidth,
	filled: mode === 'filled',
	outlined: mode === 'outlined',
	selected: selected,
	selectionnable: selectionnable,
	'box-shadow-soft': shadowVariant === 'soft',
	'box-shadow-strong': shadowVariant === 'strong'
  }">
	<ng-content></ng-content>
</div>